import React from 'react';
import * as timelineStyle from "./timeline.module.scss";
import * as style from './imageCallout.module.scss';
import Button from '../ui/button';

const RelatedStory = props => (
  <div className={`${timelineStyle.timelineBlock}`}>
    <div className={`row row--center-vert ${style.calloutItemGradientPad}`}>
      <div
        className={`${
          style.textWrap
        } col-xs-12 col-md-7 col-lg-5 push-xs-1 push-md-2 push-lg-4 fadeInBlur reveal reveal-delay-500
          `}
      >
        {props.label && (
          <span className={timelineStyle.label}>{props.label}</span>
        )}
        <h2 className={timelineStyle.headerMed}>{props.heading}</h2>
        {props.text && props.text.includes('<p>') ? (
          <div dangerouslySetInnerHTML={{ __html: props.text }} />
        ) : (
          <p>{props.text}</p>
        )}
        {props.cta_link && (
          <p style={{ paddingTop: '10px' }}>
            <Button
              color="white"
              to={props.cta_link.url}
              text={props.cta_link.title}
            />
          </p>
        )}
      </div>
      {props.src && (
        <div
          className={`${
            style.imgRound
          }  col-xs-15  col-md-4 push-md-1 push-lg-pt5 col-lg-2-pt5 reveal fadeInUp`}
        >
          <div style={{ backgroundImage: `url(${props.src})` }} />
        </div>
      )}
      <div className={`${style.calloutItemGradient} reveal swipeIn`} />
    </div>
  </div>
);

export default RelatedStory;
